"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleMap = void 0;
var DoubleMap = /** @class */ (function () {
    function DoubleMap() {
        this.store = new Map();
    }
    DoubleMap.prototype.clear = function (upperKey) {
        var _a;
        if (upperKey) {
            (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.clear();
        }
        else {
            this.store.clear();
        }
    };
    DoubleMap.prototype.delete = function (upperKey, lowerKey) {
        var _a;
        (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.delete(lowerKey);
    };
    DoubleMap.prototype.get = function (upperKey, lowerKey) {
        var _a, _b;
        return (_b = (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.get(lowerKey)) !== null && _b !== void 0 ? _b : null;
    };
    DoubleMap.prototype.has = function (upperKey, lowerKey) {
        var lm = this.store.get(upperKey);
        if (lm) {
            return (lowerKey === undefined) ? true : lm.has(lowerKey);
        }
        return false;
    };
    DoubleMap.prototype.set = function (upperKey, lowerKey, value) {
        var _a;
        var lm = (_a = this.store.get(upperKey)) !== null && _a !== void 0 ? _a : this.allocate(upperKey);
        lm.set(lowerKey, value);
        return this;
    };
    DoubleMap.prototype.keys = function (upperKey) {
        var _a, _b;
        return upperKey === undefined ? this.store.keys() : (_b = (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.keys()) !== null && _b !== void 0 ? _b : [][Symbol.iterator]();
    };
    DoubleMap.prototype.values = function (upperKey) {
        var _a, _b;
        return upperKey === undefined ? this.store.values() : (_b = (_a = this.store.get(upperKey)) === null || _a === void 0 ? void 0 : _a.values()) !== null && _b !== void 0 ? _b : [][Symbol.iterator]();
    };
    DoubleMap.prototype.allocate = function (upperKey) {
        var lm = new Map();
        this.store.set(upperKey, lm);
        return lm;
    };
    DoubleMap.prototype[Symbol.iterator] = function () {
        return this.store[Symbol.iterator]();
    };
    return DoubleMap;
}());
exports.DoubleMap = DoubleMap;
